
import { useState } from "react";
import { PrayerTime } from "@/types/page";

interface UsePrayerTimesStateProps {
  initialPrayerTimes: PrayerTime[];
  initialBlockTitle: string;
  initialAnimationSpeed: number;
  initialIsLegacyFormat: boolean;
  initialOriginalContentFormat: any;
}

export function usePrayerTimesState({
  initialPrayerTimes,
  initialBlockTitle,
  initialAnimationSpeed,
  initialIsLegacyFormat,
  initialOriginalContentFormat,
}: UsePrayerTimesStateProps) {
  const [activeTab, setActiveTab] = useState<string>("editor");
  const [isLegacyFormat, setIsLegacyFormat] = useState<boolean>(initialIsLegacyFormat);
  const [originalContentFormat, setOriginalContentFormat] = useState<any>(initialOriginalContentFormat);

  // State management
  const [prayerTimes, setPrayerTimes] = useState<PrayerTime[]>(initialPrayerTimes);
  const [blockTitle, setBlockTitle] = useState<string>(initialBlockTitle);
  const [animationSpeed, setAnimationSpeed] = useState<number>(initialAnimationSpeed);
  const [hasChanges, setHasChanges] = useState(false);

  return {
    activeTab,
    setActiveTab,
    isLegacyFormat,
    setIsLegacyFormat,
    originalContentFormat,
    setOriginalContentFormat,
    prayerTimes,
    setPrayerTimes,
    blockTitle,
    setBlockTitle,
    animationSpeed,
    setAnimationSpeed,
    hasChanges,
    setHasChanges
  };
}
